import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, Modal, notification, Row, Spin} from "antd";
import '../modals.css';
import {companyService, distributionCenterService} from "../../../services";
import {legalEntityService} from "../../../services/legal-entity.service";
import i18n from "../../../i18n";
import ModalUploadAdditionalLegalEntityDocs from "../upload-additional-legal-entity-docs";
import ModalEditLegalEntityConsignorGosLog from "../edit-legal-entity-consignor-gos-log";
import ModalEditLegalEntityGosLog from "../edit-legal-entity-gos-log";
import ModalAddConsignorGosLogWithApproveDocs from "../add-consignor-gos-log-with-approve-docs";

export default function ModalCreateOrderToConsignor({
                                                      isShow,
                                                      setNeedUpdateOrdersList,
                                                      setIsShow,
                                                      legalEntityId,
                                                      consignorId
                                                    }) {

  const [loading, setLoading] = useState(true);
  const [needUpdateDistList, setNeedUpdateDistList] = useState(true);
  const [distributionCentersList, setDistributionCentersList] = useState([]);
  const [showUploadDocsModal, setShowUploadDocsModal] = useState(false);
  const [missingDocs, setMissingDocs] = useState([]);
  const [checkingDocs, setCheckingDocs] = useState(false);
  const [showConsignorGosLogModal, setShowConsignorGosLogModal] = useState(false);
  const [showLegalEntityGosLogModal, setShowLegalEntityGosLogModal] = useState(false);
  const [legalEntityName, setLegalEntityName] = useState('');
  const [isShowAddConsignorGosLogApproveDocs, setShowAddConsignorGosLogApproveDocs] = useState(false);

  const buttonStyle = {
    width: '290px'
  };

  const fetchDistributionCenters = () => {
    distributionCenterService.getCompaniesOnApproveOrderCreate(legalEntityId, consignorId)
      .then((response) => {
        setDistributionCentersList(response);
        setLoading(false);
        setNeedUpdateDistList(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getCompanies2'),
          description: err,
        });

        setLoading(false);
        setNeedUpdateDistList(false);
      });
  };

    const checkAndFetchDistributionCenters = () => {
        if (!legalEntityId || !consignorId) {
            return;
        }

        setLoading(true);
        setCheckingDocs(true);

        legalEntityService.checkGosLog(legalEntityId, consignorId)
            .then((gosLogInfo) => {
                if (gosLogInfo && gosLogInfo.gosLogApproveRequired === true) {
                    if (gosLogInfo.isConfirmPlatform === true) {
                        setShowAddConsignorGosLogApproveDocs(true);
                    } else {
                        setShowConsignorGosLogModal(true);
                    }
                    setLoading(false);
                    setCheckingDocs(true);
                   
                }

                if (gosLogInfo && gosLogInfo.gosLogRequired === true) {
                    return companyService.getLegalEntityData(legalEntityId)
                        .then((le) => {
                            const name = (le && le.Name) ? le.Name : '';
                            setLegalEntityName(name);
                            setShowLegalEntityGosLogModal(true);
                            setLoading(false);
                            setCheckingDocs(true);
                           
                        })
                        .catch(() => {
                            setLegalEntityName('');
                            setShowLegalEntityGosLogModal(true);
                            setLoading(false);
                            setCheckingDocs(true);
                            
                        });
                }

                return legalEntityService.checkLegalEntityDocs(legalEntityId, consignorId);
            })
            .then((docsCheckResult) => {
                if (!docsCheckResult) return;
                if (docsCheckResult.data && docsCheckResult.data.length > 0) {
                    setMissingDocs(docsCheckResult.data);
                    setShowUploadDocsModal(true);
                    setLoading(false);
                } else {
                    setCheckingDocs(false);
                    fetchDistributionCenters();
                }
            })
            .catch((err) => {
                notification.error({
                    message: i18n.t('components.notification.titles.error'),
                    description: err,
                });
                setLoading(false);
                setCheckingDocs(false);
                setNeedUpdateDistList(false); 
            });
    };
    const hasChecked = useRef(false);

    useEffect(() => {
        if (isShow && needUpdateDistList && legalEntityId && consignorId && !checkingDocs && !showConsignorGosLogModal && !showLegalEntityGosLogModal) {
            if (!hasChecked.current) {
                hasChecked.current = true;
                checkAndFetchDistributionCenters();
            }
        }
    }, [isShow, needUpdateDistList, legalEntityId, consignorId, checkingDocs, showConsignorGosLogModal, showLegalEntityGosLogModal]);

  const handleSendOrderToConsignor = (legalEntityId, consignorId, distCenterId) => {
    setLoading(true);

     
    companyService
      .createOrderToConsignor(legalEntityId, consignorId, distCenterId)
      .then(resp => {
        if (resp.code !== 400) {
          notification.success({
            message: i18n.t('components.notification.titles.createOrder'),
            description: resp.message,
          });

          window.location.reload();

          setIsShow(false);
          setNeedUpdateOrdersList(true);
          setLoading(false);
        } else {
          notification.error({
            message: i18n.t('components.notification.titles.createOrder'),
            description: resp.message,
          });
        }
      })
      .catch(errMsg => {
        notification.error({
          message: i18n.t('components.notification.titles.createOrder'),
          description: errMsg,
        });
      });
  };

    // Обработчик закрытия модалки ГосЛог
    const handleCloseGosLogModal = (value) => {
        setShowConsignorGosLogModal(value);
        if (!value) {
            setCheckingDocs(false);
            setNeedUpdateDistList(false); // Сбрасываем флаг - не продолжаем
            setLoading(false);
            hasChecked.current = false;
        }
    };
    // Обработчик успешного сохранения в модалке ГосЛог
    const handleGosLogSubmitSuccess = (message) => {
        notification.success({
            message: i18n.t('Обновление статуса регистрации в ГосЛог'),
            description: message,
        });
        setShowConsignorGosLogModal(false);
        // НЕ вызываем checkAndFetchDistributionCenters()
        // НЕ устанавливаем needUpdateDistList(true)
        setCheckingDocs(true);
        setNeedUpdateDistList(true); // Останавливаем дальнейшее выполнение
        setLoading(false);
        hasChecked.current = false;
    };

    const handleCloseLegalEntityGosLogModal = (value) => {
        setShowLegalEntityGosLogModal(value);
        if (!value) {
            setCheckingDocs(false);
            setNeedUpdateDistList(false);
            setLoading(false);
            hasChecked.current = false;
        }
    };
  const ordersButtonsRender = () => {
    return distributionCentersList.map((distCenter) => {
      if (distCenter.IsActive) {
        return (
          <Col lg={8} sm={24}>
            <Button style={buttonStyle}
                    onClick={() => handleSendOrderToConsignor(legalEntityId, consignorId, distCenter.Id)}
                    className="small-button typical-btn-green">
              {distCenter.VisibleName}
            </Button>
          </Col>
        );
      }
    })
  };


  return (
    <>
      <Modal
        title={<span className="ant-modal-title">{i18n.t('modals.modalCreateOrderToConsignor.title')}</span>}
        cancelText={i18n.t('main.buttons.close')}
        className="modal-window"
        style={{maxWidth: '450px'}}
        align={null}
        visible={isShow}
        footer={null}
        onCancel={() => {
          setIsShow(false);
          setLoading(true);
          setNeedUpdateDistList(true);
          setCheckingDocs(false);
          setDistributionCentersList([]);
          setNeedUpdateDistList(true);
            hasChecked.current = false;
        }}
      >
        <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
          <Row className="add-padding-10 -centered">
            {ordersButtonsRender()}
          </Row>
        </Spin>
      </Modal>

      <ModalUploadAdditionalLegalEntityDocs
          isShow={showUploadDocsModal}
          setIsShow={(value) => {
              setShowUploadDocsModal(value);
              if (!value) {
                  // Модалка закрыта без сохранения
                  setCheckingDocs(false);
                  setLoading(false);
              }
          }}
          legalEntityId={legalEntityId}
          consignorId={consignorId}
          missingDocs={missingDocs}
          setCheckingDocs={setCheckingDocs}
          onSuccess={() => {
              // ✅ После успешного сохранения документов
              setShowUploadDocsModal(false);
              setCheckingDocs(false);
              setLoading(true);
              // ✅ Вызываем fetchDistributionCenters
              fetchDistributionCenters();
          }}
      />

        <ModalEditLegalEntityConsignorGosLog
            isShow={showConsignorGosLogModal}
            setIsShow={handleCloseGosLogModal}
            consignorId={consignorId}
            legalEntityId={legalEntityId}
            onSubmitSuccess={handleGosLogSubmitSuccess}
        />
        <ModalEditLegalEntityGosLog
            isShow={showLegalEntityGosLogModal}
            setIsShow={handleCloseLegalEntityGosLogModal}
            legalEntityId={legalEntityId}
            legalEntityName={legalEntityName}
            setIsNeedUpdate={(value) => {
                if (value) {
                    setShowLegalEntityGosLogModal(false);
                    setCheckingDocs(false);
                    setNeedUpdateDistList(true);
                    hasChecked.current = false;
                    checkAndFetchDistributionCenters();
                }
            }}
        />

        <ModalAddConsignorGosLogWithApproveDocs
            isShow={isShowAddConsignorGosLogApproveDocs}
            setIsShow={setShowAddConsignorGosLogApproveDocs}
            text='Для этой компании необходимо собственное согласовние ГосЛог. Мы автоматически направим Ваши, ранее загруженные документы, для согласования'
            consignorId={consignorId}
            legalEntityId={legalEntityId}
            onSubmitSuccess={(message) => {
                notification.success({
                    message: i18n.t('components.notification.titles.createOrder2'),
                    description: message,
                });
            }}
            
            
        />
    </>
  );
}
